import { render, staticRenderFns } from "./import-pipes.vue?vue&type=template&id=451014ff"
import script from "./import-pipes.vue?vue&type=script&lang=js"
export * from "./import-pipes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports